var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimePrediction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E2E2E2;}\r\n\t.st1{opacity:0.4;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{opacity:0.5;}\r\n\t.st4{fill:#4E6575;}\r\n\t.st5{fill:#FFAB03;}\r\n\t.st6{opacity:0.25;}\r\n\t.st7{fill:#7CB5E8;}\r\n\t.st8{fill:#EF4A51;}\r\n\t.st9{opacity:0.2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.6,35.4V23.4c0-1.9-1.5-3.4-3.4-3.4h-31h-3.4c1.9,0,3.4,1.5,3.4,3.4v43.1c0,1.9,1.5,3.4,3.4,3.4 c1.9,0,3.4-1.5,3.4-3.4v-3.4h27.6v-9.7c-3.6,1.6-8,0.9-10.9-2c-3.8-3.8-3.8-10.1,0-13.9C72.6,34.5,77,33.8,80.6,35.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.1,20H59.6v7.7c0,5.8,3.1,10.9,7.6,13.8c0.5-1.5,1.3-2.8,2.4-4c2.9-2.9,7.3-3.6,10.9-2V23.4 C80.6,21.5,79.1,20,77.1,20z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.1,20H62.9c0,1.8,1.5,3.3,3.3,3.3h11.6v11.4c1,0.1,2,0.4,2.9,0.8V23.4C80.6,21.5,79.1,20,77.1,20z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.4,55.2l3.6,3.6c0.8,0.8,2.2,0.8,3,0c0.8-0.8,0.8-2.2,0-3l-3.6-3.6L84.4,55.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M83.6,51.4c-0.5,0.5-1.1,0.9-1.7,1.3l2.5,2.5l3-3l-2.5-2.5C84.6,50.3,84.1,50.8,83.6,51.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.9,49.6c-0.4,0.6-0.8,1.1-1.3,1.7c-0.1,0.1-0.2,0.2-0.3,0.3l4.8,4.8c0.8,0.8,2.2,0.8,3,0 c0.1-0.1,0.2-0.2,0.3-0.3c-0.1-0.1-0.2-0.2-0.3-0.3L84.9,49.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.7,20c-1.9,0-3.4,1.5-3.4,3.4v3.4h6.9v-3.4C46.1,21.5,44.6,20,42.7,20z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M53,63.1v3.4c0,1.9-1.5,3.4-3.4,3.4h32.8c1.9,0,3.4-1.5,3.4-3.4v-3.4H53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 76.6,
    cy: 44.4,
    r: 9.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.3,35.6c-1.8,3.7-1.2,8.2,1.9,11.3s7.6,3.7,11.3,1.9c1.8-3.7,1.2-8.2-1.9-11.3 C80.5,34.4,76,33.8,72.3,35.6L72.3,35.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.6,30.3H53v5.2h-3.4V30.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.5,26.9h3.4v8.6h-3.4V26.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M63.4,23.4h3.4v12.1h-3.4V23.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.9,32.5c0,0.8,0.6,1.4,1.4,1.4h0.5V23.4h-1.9L64.9,32.5L64.9,32.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58,32.5c0,0.8,0.6,1.4,1.4,1.4h0.5v-7.1H58L58,32.5L58,32.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.1,32.5c0,0.8,0.6,1.4,1.4,1.4H53v-3.6h-1.9L51.1,32.5L51.1,32.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.6,37.4c-2.2-2.2-5.2-3.1-8.1-2.8c-1.5,0.2-1.4,2.5,0,2.6c0.1,0,0.3,0,0.4,0c3.1-0.3,6.1,1.4,7.4,4.4 c0.4,0.8,0.4,1.7,0.5,2.6v0c0.2,1.6,2.6,1.4,2.6-0.2C86.4,41.7,85.4,39.3,83.6,37.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,63.4c0,1.5,1.2,2.7,2.7,2.7h19.7v-2.9H63.4V63.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.1,47.3c-0.4,0-0.6-0.3-0.6-0.6V46c0-1.3,0.6-2.5,1.5-3.2c0.5-0.3,0.7-0.9,0.6-1.5 c-0.1-0.6-0.6-1.1-1.2-1.2c-0.5-0.1-0.9,0-1.3,0.3c-0.3,0.3-0.5,0.7-0.5,1.2c0,0.4-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6 c0-0.8,0.4-1.6,1-2.1s1.5-0.8,2.3-0.6c1.1,0.2,2.1,1.1,2.3,2.3c0.2,1.1-0.2,2.1-1.1,2.8c-0.6,0.4-1,1.3-1,2.1v0.6 C77.8,47,77.5,47.3,77.1,47.3L77.1,47.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 77.1,
    cy: 48.8,
    r: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.8,64.5c-0.2,0-0.3-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-0.9l11-11c0.3-0.3,0.7-0.3,0.9,0 c0.3,0.3,0.3,0.7,0,0.9l-11,11C43.1,64.4,42.9,64.5,42.8,64.5L42.8,64.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.7,56.8c-0.2,0-0.3-0.1-0.5-0.2L57,53.3c-0.3-0.3-0.3-0.7,0-0.9c0.3-0.3,0.7-0.3,0.9,0l3.2,3.2 c0.3,0.3,0.3,0.7,0,0.9C61,56.7,60.8,56.8,60.7,56.8L60.7,56.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.3,56.8c-0.2,0-0.3-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-0.9l3.2-3.2c0.3-0.3,0.7-0.3,0.9,0 c0.3,0.3,0.3,0.7,0,0.9l-3.2,3.2C64.7,56.7,64.5,56.8,64.3,56.8L64.3,56.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M63.4,39.6H49.6c-0.4,0-0.6-0.3-0.6-0.6c0-0.4,0.3-0.6,0.6-0.6h13.8c0.4,0,0.6,0.3,0.6,0.6 C64,39.3,63.7,39.6,63.4,39.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M63.4,43.1H49.6c-0.4,0-0.6-0.3-0.6-0.6c0-0.4,0.3-0.6,0.6-0.6h13.8c0.4,0,0.6,0.3,0.6,0.6 C64,42.8,63.7,43.1,63.4,43.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58.2,46.5h-8.6c-0.4,0-0.6-0.3-0.6-0.6c0-0.4,0.3-0.6,0.6-0.6h8.6c0.4,0,0.6,0.3,0.6,0.6 C58.8,46.2,58.5,46.5,58.2,46.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 40.9,
    cy: 65.7,
    r: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 62.5,
    cy: 57.9,
    r: 2.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.9,63.1c-0.3,0-0.6,0.1-0.8,0.2c-0.1,0.3-0.2,0.5-0.2,0.8c0,1.4,1.2,2.6,2.6,2.6c0.3,0,0.6-0.1,0.8-0.2 c0.1-0.3,0.2-0.5,0.2-0.8C43.5,64.3,42.4,63.1,40.9,63.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.5,55.3c-0.3,0-0.6,0.1-0.8,0.2c-0.1,0.3-0.2,0.5-0.2,0.8c0,1.4,1.2,2.6,2.6,2.6c0.3,0,0.6-0.1,0.8-0.2 c0.1-0.3,0.2-0.5,0.2-0.8C65.1,56.5,63.9,55.3,62.5,55.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 55.6,
    cy: 51,
    r: 2.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.6,48.4c-0.3,0-0.6,0.1-0.8,0.2c-0.1,0.3-0.2,0.5-0.2,0.8c0,1.4,1.2,2.6,2.6,2.6c0.3,0,0.6-0.1,0.8-0.2 c0.1-0.3,0.2-0.5,0.2-0.8C58.2,49.6,57,48.4,55.6,48.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePrediction);
export default __webpack_public_path__ + "static/media/TimePrediction.40c76e244b19ffd3f2a15a39e4b74777.svg";
export { ForwardRef as ReactComponent };